import { useEffect, useState } from 'react';
import cookies from 'js-cookie';

import { getSegmentClient } from '../modules/analytics';

export const useUserId = userId => {
  const [user, setUser] = useState({ id: '', isAnonymousUser: true });
  const segment = getSegmentClient();

  useEffect(() => {
    segment.ready(() => {
      if (userId) {
        setUser({ id: userId, isAnonymousUser: false });
      } else {
        setUser({
          id: cookies.get('ajs_anonymous_id'),
          isAnonymousUser: true,
        });
      }
    });
  }, [segment, userId]);

  return user;
};
